import React from "react";
import PropTypes from "prop-types";
import styles from "./Footer.module.css";
import FooterList from "../FooterList";
import classNames from "classnames";

export default function Footer({ lists, inverse }) {
  const currentYear = new Date().getFullYear();
  return (
    <div className={`${styles.footer} ${inverse ? styles.inverse : ""}`}>
      <div className={styles.container}>
        <div className={styles.row}>
          {lists.length > 0 ? (
            lists.map((list, index) => (
              <div key={index} className={styles.spacing}>
                <FooterList header={list.header} links={list.links} />
              </div>
            ))
          ) : (
            <></>
          )}
        </div>
        <div className={classNames(styles.row, styles.center)}>
          <p className={styles.credits}>Copyright © 1993-{currentYear}</p>
        </div>
      </div>
    </div>
  );
}

Footer.propTypes = {
  lists: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string,
      links: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          src: PropTypes.string,
        })
      ),
    })
  ),
  inverse: PropTypes.bool,
};
